import { render, staticRenderFns } from "./Jogos.vue?vue&type=template&id=3c5c33d8&scoped=true&"
import script from "./Jogos.vue?vue&type=script&lang=ts&"
export * from "./Jogos.vue?vue&type=script&lang=ts&"
import style0 from "./Jogos.vue?vue&type=style&index=0&id=3c5c33d8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c5c33d8",
  null
  
)

export default component.exports